// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__22jLI","text":"SelectPayment_text__2J-PA","title":"SelectPayment_title__2srUO","btn":"SelectPayment_btn__1Bi7j"};